import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "~/components/ui/popover.jsx";
import { Button } from "~/components/ui/button.jsx";
import { router } from "@inertiajs/react";
import { Badge } from "~/components/ui/badge.jsx";
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from "~/components/ui/drawer.jsx";
import ProductPropertyFilter from "@/components/products/ProductPropertyFilter.jsx";
import * as reactUse from "react-use";
import { PhoneCall, PhoneIcon } from "lucide-react";
import ContactRequestFormMini from "~/components/ContactRequestFormMini";
import telegramIcon from "@/images/icons/telegram.png";
import whatsappIcon from "@/images/icons/whatsapp.png";
import viberIcon from "@/images/icons/viber.png";
import phoneIcon from "@/images/icons/phone-call.png";
import { Heading } from "./ui/heading";

const { useMedia } = reactUse;

export default function () {
  const isDesktop = useMedia("(width >= 64rem)");

  return (
    <div className="fixed bottom-4 xl:bottom-8 right-4 xl:right-8">
      {isDesktop ? (
        <Popover>
          <PopoverTrigger asChild>
            <ButtonComp />
          </PopoverTrigger>
          <PopoverContent
            className="mt-4"
            sideOffset={20}
            side="top"
            align="end"
          >
            <Content />
          </PopoverContent>
        </Popover>
      ) : (
        <Drawer>
          <DrawerTrigger asChild>
            <ButtonComp />
          </DrawerTrigger>
          <DrawerContent className="h-full mx-auto w-full max-w-sm px-7 pb-7">
            {/* <DrawerHeader>
              <DrawerTitle>Контакты</DrawerTitle>
              <DrawerDescription className="">
                This action cannot be undone.
              </DrawerDescription>
            </DrawerHeader> */}
            <div className="py-7">
              <Content />
            </div>
            <DrawerFooter className="hidden">
              <Button>Submit</Button>
              <DrawerClose>
                <Button variant="outline">Cancel</Button>
              </DrawerClose>
            </DrawerFooter>
          </DrawerContent>
        </Drawer>
      )}
    </div>
  );
}

const ButtonComp = (props) => (
  <button className="p-4 bg-black rounded-full hover:animate-pulse" {...props}>
    <PhoneCall className="size-8 text-white" />
  </button>
);

function Content() {
  return (
    <div className="text-center">
      <Heading size="h5" className="pb-4 text-center">
        Позвонить нам
      </Heading>
      <div className="text-2xl">
        <a
          href="tel:+79029274257"
          className="flex items-center space-x-1 justify-center"
        >
          <PhoneCall />
          <span>8-902-927-42-57</span>
        </a>
      </div>

      <hr className="my-8" />

      <div>
        <Heading size="h5" className="pb-4 text-center">
          Написать нам
        </Heading>
        <div className="flex space-x-4 items-center justify-center">
          <div className="flex space-x-4 items-center">
            <div>
              <a
                href="https://wa.me/79029274257"
                target="_blank"
                rel="noreferrer"
              >
                <img src={whatsappIcon} className="size-10" />
              </a>
            </div>
            <div>
              <a
                href="https://t.me/shararam24"
                target="_blank"
                rel="noreferrer"
              >
                <img src={telegramIcon} className="size-10" />
              </a>
            </div>
            <div>
              <a href="tel:+79029274257" target="_blank" rel="noreferrer">
                <img src={phoneIcon} className="size-10" />
              </a>
            </div>
          </div>
        </div>
      </div>

      <hr className="my-8" />
      <div>
        <Heading size="h5" className="pb-4 text-center">
          Обратный звонок
        </Heading>
        <ContactRequestFormMini />
      </div>
    </div>
  );
}
